/* Category flyouts keep the original tool nodes and native delegated handlers. */
(()=>{'use strict';
  window.MyersCADCategoryRail={create({rails,toolbar,make}){
    const entries=[],slots={},menus={},counts={};let layout=null,workspace=null,active=null,closeTimer=0;
    const setClass=(node,name,on)=>{if(node.classList.contains(name)!==on)node.classList.toggle(name,on);};
    function close(restoreFocus=false){
      clearTimeout(closeTimer);closeTimer=0;
      if(!active)return;const entry=active;active=null;
      entry.group.hidden=true;entry.button.setAttribute('aria-expanded','false');
      if(restoreFocus)entry.button.focus();
    }
    function position(entry){
      const anchor=entry.button.getBoundingClientRect(),rail=rails[entry.workspace].getBoundingClientRect();
      const panel=entry.group;const width=Math.max(120,window.innerWidth-rail.right-12);
      panel.style.maxWidth=width+'px';panel.style.maxHeight=Math.max(90,window.innerHeight-20)+'px';
      panel.style.left=Math.round(rail.right-1)+'px';panel.style.top=Math.max(8,Math.round(anchor.top))+'px';
      const rect=panel.getBoundingClientRect();
      panel.style.top=Math.max(8,Math.min(Math.round(anchor.top),window.innerHeight-rect.height-8))+'px';
    }
    function open(entry,focus=false){
      if(layout==='all')return;
      clearTimeout(closeTimer);if(active!==entry)close();
      active=entry;entry.group.hidden=false;entry.button.setAttribute('aria-expanded','true');
      entry.group.dataset.flyout=layout;position(entry);
      if(focus)entry.group.querySelector('button:not(:disabled),input:not(:disabled),summary')?.focus();
    }
    const delayClose=()=>{clearTimeout(closeTimer);closeTimer=setTimeout(()=>close(),220);};
    for(const name of ['model','sketch']){
      const rail=rails[name];if(!rail)continue;
      rail.classList.add('category-capable');
      const slot=make('div','rail-history-slot');slots[name]=slot;
      const menu=make('div','rail-categories');menu.setAttribute('role','toolbar');menu.setAttribute('aria-label',name==='model'?'Model tool categories':'Sketch tool categories');menus[name]=menu;
      const top=rail.querySelector('.railTop');top.before(slot);
      const list=rail.querySelector('.railList');list.before(menu);counts[name]=0;
      for(const group of rail.querySelectorAll('.railGroup')){
        if(group.classList.contains('history-relocated')||!group.querySelector('button,summary,input'))continue;
        const label=group.getAttribute('aria-label')||group.querySelector('.railHeading')?.textContent?.trim()||'Tools';
        if(label==='History')continue;
        const button=make('button','rail-category-button');button.type='button';
        const id='category-'+name+'-'+(++counts[name]);group.id=group.id||id+'-tools';
        button.style.setProperty?.('--category-color',group.style.getPropertyValue?.('--group-color')||'#527e90');
        button.id=id;button.title=label;button.setAttribute('aria-label',label);button.setAttribute('aria-controls',group.id);button.setAttribute('aria-expanded','false');
        const icon=group.querySelector('.action-icon')?.cloneNode(true);
        if(icon){if(label==='Artwork')icon.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><rect x="3" y="4" width="18" height="16" rx="2"/><circle cx="8" cy="9" r="2"/><path d="m3 18 6-5 4 3 4-6 4 7"/></svg>';button.append(icon);}
        const caption=make('span','category-caption');caption.textContent=label;button.append(caption);
        menu.append(button);group.classList.add('category-tools-panel');group.setAttribute('aria-labelledby',id);
        const entry={workspace:name,group,button,originalHidden:group.hidden};entries.push(entry);
        button.addEventListener('pointerenter',event=>{if(event.pointerType!=='touch')open(entry);});
        button.addEventListener('pointerleave',delayClose);
        button.addEventListener('click',event=>{event.stopPropagation();active===entry?close():open(entry);});
        button.addEventListener('keydown',event=>{
          if(['ArrowRight','ArrowDown','Enter',' '].includes(event.key)){
            event.preventDefault();event.stopPropagation();open(entry,true);
          }else if(event.key==='Escape'){event.preventDefault();close(true);}
        });
        group.addEventListener('pointerenter',()=>clearTimeout(closeTimer));group.addEventListener('pointerleave',delayClose);
        group.addEventListener('focusout',event=>{if(!group.contains(event.relatedTarget)&&event.relatedTarget!==button)delayClose();});
        group.addEventListener('click',event=>{
          const target=event.target.closest('button');
          if(target&&!target.disabled)queueMicrotask(()=>close(event.detail===0));
        });
        group.addEventListener('keydown',event=>{
          if(event.key==='Escape'||layout==='vertical'&&event.key==='ArrowLeft'){event.preventDefault();event.stopPropagation();close(true);return;}
          const keys=layout==='horizontal'?['ArrowLeft','ArrowRight']:['ArrowUp','ArrowDown'];
          if(!event.target.closest('button'))return;
          if(!keys.includes(event.key)&&!['Home','End'].includes(event.key))return;
          const buttons=[...group.querySelectorAll('button:not(:disabled)')].filter(b=>!b.hidden&&!b.closest('[hidden]'));
          if(!buttons.length)return;const index=buttons.indexOf(document.activeElement);
          const next=event.key==='Home'?0:event.key==='End'?buttons.length-1:(index+(event.key===keys[0]?-1:1)+buttons.length)%buttons.length;
          event.preventDefault();event.stopPropagation();buttons[next].focus();
        });
      }
      menu.addEventListener('keydown',event=>{
        if(!['ArrowUp','ArrowDown','Home','End'].includes(event.key))return;
        const buttons=[...menu.querySelectorAll('button')],index=buttons.indexOf(document.activeElement);
        const next=event.key==='Home'?0:event.key==='End'?buttons.length-1:(index+(event.key==='ArrowUp'?-1:1)+buttons.length)%buttons.length;
        event.preventDefault();buttons[next]?.focus();
      });
    }
    document.addEventListener('pointerdown',event=>{if(active&&!active.group.contains(event.target)&&!active.button.contains(event.target))close();});
    window.addEventListener('resize',()=>close());window.addEventListener('blur',()=>close());
    for(const rail of Object.values(rails))rail?.addEventListener('scroll',event=>{
      if(!event.target.closest?.('.category-tools-panel'))close();
    },true);
    return {close,refresh(nextLayout,nextWorkspace){
      const changed=layout!==nextLayout||workspace!==nextWorkspace;
      if(changed)close();layout=nextLayout;workspace=nextWorkspace;
      for(const name of ['model','sketch']){
        const rail=rails[name];if(!rail)continue;
        setClass(rail,'category-rail',layout!=='all');
        setClass(rail,'history-in-rail',true);
        menus[name].hidden=layout==='all';
        if(layout!=='all')rail.querySelector('.railList').hidden=false;
      }
      const historySlot=slots[workspace]||(['render','drawing','physics'].includes(workspace)?slots.model:null);
      if(historySlot){
        if(toolbar.parentElement!==historySlot)historySlot.append(toolbar);
        setClass(toolbar,'in-rail',true);
      }else{
        if(toolbar.parentElement!==document.body)document.body.append(toolbar);
        setClass(toolbar,'in-rail',false);
      }
      if(changed)for(const entry of entries){
        entry.group.hidden=layout==='all'?entry.originalHidden:true;
        entry.group.dataset.flyout=layout;
      }
      for(const entry of entries){
        setClass(entry.button,'active',!!entry.group.querySelector('button.active'));
      }
      if(active)position(active);
    }};
  }};
})();
